import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { audioNotifier, type ChatAudioSettings, type AudioSettings as NotifierAudioSettings } from "@/lib/audio-notifier";
import type { NotificationSound } from "@shared/schema";

interface AudioSettings extends NotifierAudioSettings {
  availableSounds: NotificationSound[];
}

interface UserPreferences {
  chatAudioSettings?: ChatAudioSettings;
}

export function useAudioNotifierInit() {
  const { data: settings } = useQuery<AudioSettings>({
    queryKey: ['/api/user/audio-settings'],
  });

  const { data: preferences } = useQuery<UserPreferences>({
    queryKey: ['/api/user/preferences'],
  });

  useEffect(() => {
    if (settings) {
      audioNotifier.preloadUserSounds(settings);
    }
  }, [settings]);

  // Load chat-specific audio settings
  useEffect(() => {
    if (preferences?.chatAudioSettings && settings?.availableSounds) {
      audioNotifier.updateChatAudioSettings(
        preferences.chatAudioSettings, 
        settings.availableSounds
      );
    }
  }, [preferences?.chatAudioSettings, settings?.availableSounds]);

  return settings?.audioNotificationsEnabled ?? false;
}
